import { createAsyncThunk } from '@reduxjs/toolkit';
import { notify } from 'components/Common/Toast';
import { getProblemDetail } from 'api/v1Helpers';
import { createPaymentRequest } from 'services/paymentRequestsApi';
import type { PaymentRequest } from 'types/paymentRequests';

export type SendInvoicePayload = {
    parishId: string;
    recipientId: string;
    amountCents: number;
    subject: string;
};

/**
 * Create a PaymentRequest via POST /v1/parishes/:parishId/payment-requests.
 * Success means the request row (+ notification/outbox) was created — not that SMTP delivered.
 */
export const sendInvoice = createAsyncThunk<PaymentRequest, SendInvoicePayload>(
    'invoice/sendInvoice',
    async (payload, { rejectWithValue }) => {
        try {
            const created = await createPaymentRequest(payload.parishId, {
                recipientId: payload.recipientId,
                amountCents: payload.amountCents,
                subject: payload.subject,
            });
            notify('Payment request created', 'success');
            return created;
        } catch (err) {
            const detail = getProblemDetail(err) || 'Failed to create payment request';
            notify(detail, 'error');
            return rejectWithValue(detail);
        }
    }
);
